/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/*
mutation MissionControlActivateSageIntacctMutation(
  $input: MissionControlActivateSageIntacctInput!
) {
  MissionControlActivateSageIntacct(input: $input) {
    outcome
    errorMessage
  }
}
*/
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input",
            "type": "MissionControlActivateSageIntacctInput!"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "MissionControlActivateSageIntacctPayload",
            "kind": "LinkedField",
            "name": "MissionControlActivateSageIntacct",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "outcome",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "errorMessage",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "MissionControlActivateSageIntacctMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "MissionControlActivateSageIntacctMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": null,
            "metadata": {},
            "name": "MissionControlActivateSageIntacctMutation",
            "operationKind": "mutation",
            "text": "mutation MissionControlActivateSageIntacctMutation(\n  $input: MissionControlActivateSageIntacctInput!\n) {\n  MissionControlActivateSageIntacct(input: $input) {\n    outcome\n    errorMessage\n  }\n}\n"
        }
    };
})();
node.hash = '59c4e567962df13777f88e4420ad7766';
export default node;
